
    <!--
 * 竖版-活动任务
 * @LastEditTime: Mon Aug 05 2024 21:41:13 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_DIDC46"  :class="[`normal teamTaskSection`,`u_c_DIDC46`]" ><div id="u_c_TCEI47"  :class="[`${ compData.title ? 'text' : '' }`,`normal task-title`,`u_c_TCEI47`]" ><div id="u_c_OCV248"  :class="[compData.activeTab == 'team' ? 'active-tab' : '',`normal`,`u_c_OCV248`]" @click="u_c_OCV248_event_AXJ783($event)">{{langData.teamTask}}</div><div id="u_c_MHT350"  :class="[compData.activeTab == 'personal' ? 'active-tab' : '',`normal`,`u_c_MHT350`]" @click="u_c_MHT350_event_XSXX85($event)">{{langData.personalTask}}</div></div><div id="u_c_H0UU52"  :class="[`normal task-desc`,`u_c_H0UU52`]" ><div id="u_c_Q9IQ53"  v-html="compData.inviterDesc || langData.teamTaskDesc" v-if="compData.activeTab == 'team'" :class="[`normal`,`u_c_Q9IQ53`]" ></div><div id="u_c_RB2H54"  v-html="compData.inviteeDesc || langData.personalTaskDesc" v-if="compData.activeTab == 'personal'" :class="[`normal`,`u_c_RB2H54`]" ></div></div><div id="u_c_77JA97"  :class="[`normal`,`u_c_77JA97`]" >{{langData.curProgress}}<span id="u_c_A786102"  :class="[`normal highlight`,`u_c_A786102`]" >{{`${ compData.activeTab == 'team' ? pageData.teamPayTotal : pageData.personalPayTotal } ${ pageData.currency }`}}</span></div><div id="u_c_Q26230"  :class="[`normal txt`,`u_c_Q26230`]" ><span id="u_c_KL1C31"  :class="[`normal txt`,`u_c_KL1C31`]" @click="u_c_KL1C31_event_Y90J29($event)">{{`[${ langData.refresh }]`}}</span><span id="u_c_JGIQ33"  :class="[`normal txt`,`u_c_JGIQ33`]" @click="u_c_JGIQ33_event_Y90J29($event)">{{`[${ langData.myPackage }]`}}</span><span id="u_c_6R6U21"  :class="[`normal txt`,`u_c_6R6U21`]" @click="u_c_6R6U21_event_Y90J29($event)">{{`[${ langData.taskLog }]`}}</span></div><div id="u_c_EQ6B133"  :class="[`normal`,`u_c_EQ6B133`]" ><div id="u_c_0PIV116"  v-for="(groupItem, groupIndex) in (compData.activeTab == 'team' ? compData.teamTask : compData.soloTask)" :key="groupIndex" :class="[`normal`,`u_c_0PIV116`]" ><div id="u_c_IXM3117"  v-if="pageData.isEdit" :class="[`normal task-text`,`u_c_IXM3117`]" ><div id="u_c_PHDI21"  v-html="(groupItem.payLevelType == 'customize_level' ? langData.teamPayTotal : langData.teamPayEvery).replace('${x}${currency}', `<span class='highlight'> ${ groupItem.num } ${ pageData.currency }</span>`)" :class="[`normal`,`u_c_PHDI21`]" ></div></div><div id="u_c_C09Q26"  v-if="!pageData.isEdit" v-html="groupItem.taskName || langData[groupItem.taskValue]" :class="[`normal task-text`,`u_c_C09Q26`]" ></div><div id="u_c_9F94121"  :class="[`normal`,`u_c_9F94121`]" ><div id="u_c_8YAC122"  :class="[`normal`,`u_c_8YAC122`]" ><div id="u_c_67LY123"  v-for="(awardItem, awardIndex) in groupItem.pic" :key="awardIndex" :class="[`normal`,`u_c_67LY123`]" @click="u_c_67LY123_event_QUFC21($event,groupItem)"><div id="u_c_CIKY124"  :style="`background-image:url(${ awardItem })`" :class="[`normal`,`u_c_CIKY124`]" ></div></div></div><div id="u_c_5EOB125"  v-html="pageData.isEdit ? langData.toFinish : getBtnText(groupItem)" :class="[groupItem.state == 2 ? 'has' : '',`normal`,`u_c_5EOB125`]" @click="u_c_5EOB125_event_5IW625($event,groupItem,groupIndex)"></div></div><div id="u_c_SGL619"  :class="[`normal`,`u_c_SGL619`]" ><span id="u_c_LM5020"  v-if="groupItem.taskValue === 'pay_order'" :class="[`normal`,`u_c_LM5020`]" >{{langData.orderMoneyNoLimit}}</span><span id="u_c_U4BS22"  v-if="+groupItem.dailyLimit != -1" :class="[`normal`,`u_c_U4BS22`]" >{{+groupItem.dailyLimit ? langData.dayLimit.replace('${x}', groupItem.dailyLimit) : langData.dayNoLimit}}</span><span id="u_c_YLSD24"  v-if="+groupItem.activityLimit != -1" :class="[`normal`,`u_c_YLSD24`]" >{{+groupItem.activityLimit ? langData.activityLimit.replace('${Y}', groupItem.activityLimit) : langData.activityNoLimit}}</span></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"请先在规则配置中配置自定义事件","eventName":"请按照规则配置顺序配置自定义事件名称"}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"","payLevelType":"fixed_level","num":1,"pic":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png"],"awardDetail":"","state":"0","dailyLimit":0,"activityLimit":0}],"soloTask":[{"taskValue":"pay_total","payLevelType":"","taskName":"","pic":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713171812387-30.png"],"awardDetail":"","state":"0","dailyLimit":0,"activityLimit":0}]},"zh-CN":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"加速训练10分钟 *10、 研发加速10分钟 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"钻石 *50、 加速训练10分钟 *10、 研发加速10分钟 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"钻石 *100、 加速训练10分钟 *10、 研发加速10分钟 *10、 加速建造10分钟 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"钻石 *200、 加速训练10分钟 *10、 研发加速10分钟 *10、 加速建造10分钟 *10、 马库斯碎片 *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"加速训练10分钟 *10、 研发加速10分钟 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"钻石 *200、 加速训练60分钟 *10、 研发加速60分钟 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"5星英雄万能碎片*5、升星选择补给箱 *10、强化选择补给箱 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"马库斯碎片 *2、 精密升星选择补给箱 *10、 升星选择补给箱 *10、 强化选择补给箱 *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"zh-TW":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"加速訓練10分鐘 *10、 研發加速10分鐘 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"鑽石 *50、 加速訓練10分鐘 *10、 研發加速10分鐘 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"鑽石 *100、 加速訓練10分鐘 *10、 研發加速10分鐘 *10、 加速建造10分鐘 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"鑽石 *200、 加速訓練10分鐘 *10、 研發加速10分鐘 *10、 加速建造10分鐘 *10、 馬庫斯碎片 *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"加速訓練10分鐘 *10、 研發加速10分鐘 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"鑽石 *200、 加速訓練60分鐘 *10、 研發加速60分鐘 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"5星英雄萬能碎片*5、升星選擇補給箱 *10、強化選擇補給箱 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"馬庫斯碎片 *2、 精密升星選擇補給箱 *10、 升星選擇補給箱 *10、 強化選擇補給箱 *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"en-US":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10-min Training Speedup *10、 10-min Research Speedup *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamond *50、 10-min Training Speedup *10、 10-min Research Speedup *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond *100、 10-min Training Speedup *10、 10-min Research Speedup *10、 10-min Build Speedup *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond *200、 10-min Training Speedup *10、 10-min Research Speedup *10、 10-min Build Speedup *10、 Marcus Frag *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10-min Training Speedup *10、 10-min Research Speedup *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diamond *200、 60-min Training Speedup *10、 60-min Research Speedup *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"5★ Hero Perfect Frag*5、Promote Choice Box *10、Enhance Choice Box *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Marcus Frag *2、 Promote Choice Box II *10、 Promote Choice Box *10、 Enhance Choice Box *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"ja-JP":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"訓練ブースト（10分間） *10、 研究ブースト（10分間） *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"ダイヤ *50、 訓練ブースト（10分間） *10、 研究ブースト（10分間） *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"ダイヤ *100、 訓練ブースト（10分間） *10、 研究ブースト（10分間） *10、 建造ブースト（10分間） *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"ダイヤ *200、 訓練ブースト（10分間） *10、 研究ブースト（10分間） *10、 建造ブースト（10分間） *10、 マーカスの破片 *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"訓練ブースト（10分間） *10、 研究ブースト（10分間） *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"ダイヤ *200、 訓練ブースト（60分間） *10、 研究ブースト（60分間） *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"★5英雄の万能欠片*5、選択型プロモート補給 *10、選択型強化補給 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"マーカスの破片 *2、 選択型プロモート補給（エリート） *10、 選択型プロモート補給 *10、 選択型強化補給 *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"ko-KR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"훈련 10분 가속 *10、 개발 10분 가속 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"다이아 *50、 훈련 10분 가속 *10、 개발 10분 가속 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"다이아 *100、 훈련 10분 가속 *10、 개발 10분 가속 *10、 건설 10분 가속 *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"다이아 *200、 훈련 10분 가속 *10、 개발 10분 가속 *10、 건설 10분 가속 *10、 마커스 조각 *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"훈련 10분 가속 *10、 개발 10분 가속 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"다이아 *200、 훈련 60분 가속 *10、 개발 60분 가속 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"5성 영웅 만능 조각*5、승성 선택 보급 상자 *10、강화 선택 보급상자 *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"마커스 조각 *2、 정밀 승성 선택 보급 상자 *10、 승성 선택 보급 상자 *10、 강화 선택 보급상자 *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"th-TH":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"เพชร *50、 เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"เพชร *100、 เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10、 เร่งสปีดสร้าง10นาที *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"เพชร *200、 เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10、 เร่งสปีดสร้าง10นาที *10、 เศษ Marcus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"เพชร *200、 เร่งสปีดฝึก60นาที *10、 เร่งสปีดการวิจัย60นาที *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"ชิปวิเศษฮีโร่ 5★*5、หีบเลือกอัปดาว *10、หีบเลือกตีบวก *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"เศษ Marcus *2、 หีบเลือกอัปดาวก่อสร้าง *10、 หีบเลือกอัปดาว *10、 หีบเลือกตีบวก *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"vi-VN":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Tăng tốc huấn luyện 10 phút *10、 Tăng tốc nghiên cứu 10 phút *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Kim Cương *50、 Tăng tốc huấn luyện 10 phút *10、 Tăng tốc nghiên cứu 10 phút *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Kim Cương *100、 Tăng tốc huấn luyện 10 phút *10、 Tăng tốc nghiên cứu 10 phút *10、 Tăng tốc xây 10 phút *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Kim Cương *200、 Tăng tốc huấn luyện 10 phút *10、 Tăng tốc nghiên cứu 10 phút *10、 Tăng tốc xây 10 phút *10、 Mảnh Marcus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Tăng tốc huấn luyện 10 phút *10、 Tăng tốc nghiên cứu 10 phút *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Kim Cương *200、 Tăng tốc huấn luyện 60 phút *10、 Tăng tốc nghiên cứu 60 phút *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Mảnh Anh hùng 5 Sao Vạn Năng*5、Rương Lựa Chọn Tăng Sao *10、Rương Chọn Cường Hoá *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Mảnh Marcus *2、 Rương Chọn Tăng Sao Tuyệt Mật *10、 Rương Lựa Chọn Tăng Sao *10、 Rương Chọn Cường Hoá *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"de-DE":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10 Min Training Beschleunigen *10、 10 Min Forschung Beschleunigen *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamant *50、 10 Min Training Beschleunigen *10、 10 Min Forschung Beschleunigen *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant *100、 10 Min Training Beschleunigen *10、 10 Min Forschung Beschleunigen *10、 10 Min Bau Beschleunigen *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant *200、 10 Min Training Beschleunigen *10、 10 Min Forschung Beschleunigen *10、 10 Min Bau Beschleunigen *10、 Marcus Frag *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10 Min Training Beschleunigen *10、 10 Min Forschung Beschleunigen *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diamant *200、 60 Min Training Beschleunigen *10、 60 Min Forschung Beschleunigen *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"5★ Held-Perfektes Fragment*5、Befördern Auswahlkiste *10、Verbessern Auswahlkiste *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Marcus Frag *2、 Befördern Auswahlkiste II *10、 Befördern Auswahlkiste *10、 Verbessern Auswahlkiste *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"fr-FR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Accélération entraînement 10-min *10、 Accélération recherche 10-min *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamant *50、 Accélération entraînement 10-min *10、 Accélération recherche 10-min *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant *100、 Accélération entraînement 10-min *10、 Accélération recherche 10-min *10、 Accélération bâtiment 10-min *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant *200、 Accélération entraînement 10-min *10、 Accélération recherche 10-min *10、 Accélération bâtiment 10-min *10、 Frag de Marcus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Accélération entraînement 10-min *10、 Accélération recherche 10-min *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diamant *200、 Accélération entraînement 60-min *10、 Accélération recherche 60-min *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Fragment parfait de héros 5★*5、Boîte choix promotion *10、Boîte de renforcement au choix *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Frag de Marcus *2、 Boîte choix promotion II *10、 Boîte choix promotion *10、 Boîte de renforcement au choix *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"ru-RU":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Ускорение Обучения (10 мин.) *10、 Ускорение Исследования (10 мин.) *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Алмаз *50、 Ускорение Обучения (10 мин.) *10、 Ускорение Исследования (10 мин.) *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Алмаз *100、 Ускорение Обучения (10 мин.) *10、 Ускорение Исследования (10 мин.) *10、 Ускорение Строительства (10 мин.) *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Алмаз *200、 Ускорение Обучения (10 мин.) *10、 Ускорение Исследования (10 мин.) *10、 Ускорение Строительства (10 мин.) *10、 Фрагмент Маркуса *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Ускорение Обучения (10 мин.) *10、 Ускорение Исследования (10 мин.) *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Алмаз *200、 Ускорение Обучения (60 мин.) *10、 Ускорение Исследования (60 мин.) *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Идеальный Фрагмент 5★ Героя*5、Ящик с Промоутерами на Выбор *10、Ящик с Улучшениями на Выбор *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Фрагмент Маркуса *2、 Ящик с Промоутерами на Выбор II *10、 Ящик с Промоутерами на Выбор *10、 Ящик с Улучшениями на Выбор *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"es-ES":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10 min de Aceleración de Entrenamiento *10、 10 min de Aceleración de investigación *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamante *50、 10 min de Aceleración de Entrenamiento *10、 10 min de Aceleración de investigación *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante *100、 10 min de Aceleración de Entrenamiento *10、 10 min de Aceleración de investigación *10、 10 min de Aceleración de Construcción *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante *200、 10 min de Aceleración de Entrenamiento *10、 10 min de Aceleración de investigación *10、 10 min de Aceleración de Construcción *10、 Frag. de Marcus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10 min de Aceleración de Entrenamiento *10、 10 min de Aceleración de investigación *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diamante *200、 60 min de Aceleración de Entrenamiento *10、 60 min de Aceleración de investigación *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Frag. Perfecto de Héroe 5★*5、Caja de Selección de Promoción *10、Mejora la Caja de Elección *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Frag. de Marcus *2、 Caja de Selección de Promoción II *10、 Caja de Selección de Promoción *10、 Mejora la Caja de Elección *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"pt-PT":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10 min de Aceleração de Treinamento *10、 10 min de aceleração da Pesquisa *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamante *50、 10 min de Aceleração de Treinamento *10、 10 min de aceleração da Pesquisa *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante *100、 10 min de Aceleração de Treinamento *10、 10 min de aceleração da Pesquisa *10、 10 minutos de Aceleração de Construção *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante *200、 10 min de Aceleração de Treinamento *10、 10 min de aceleração da Pesquisa *10、 10 minutos de Aceleração de Construção *10、 Frag. de Marcus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10 min de Aceleração de Treinamento *10、 10 min de aceleração da Pesquisa *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diamante *200、 60 min de Aceleração de Treinamento *10、 60 min de aceleração da Pesquisa *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Fragmento de Herói Perfeito 5★*5、Caixa de Escolha de Promoção *10、Caixa da Escolha de Melhorias *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Frag. de Marcus *2、 Caixa de Escolha de Promoção II *10、 Caixa de Escolha de Promoção *10、 Caixa da Escolha de Melhorias *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"it-IT":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Velocizz. Addestramento 10-min *10、 Velocizz. Ricerca 10-min *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamante *50、 Velocizz. Addestramento 10-min *10、 Velocizz. Ricerca 10-min *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante *100、 Velocizz. Addestramento 10-min *10、 Velocizz. Ricerca 10-min *10、 Velocizz. Costruzione 10-min *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante *200、 Velocizz. Addestramento 10-min *10、 Velocizz. Ricerca 10-min *10、 Velocizz. Costruzione 10-min *10、 Framm. Marcus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Velocizz. Addestramento 10-min *10、 Velocizz. Ricerca 10-min *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diamante *200、 Velocizz. Addestramento 60-min *10、 Velocizz. Ricerca 60-min *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Framm. Eroe Perfetto 5★*5、Scatola Scelta Promozione *10、Scatola Scelta Migliora *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Framm. Marcus *2、 Scatola Scelta Promozione II *10、 Scatola Scelta Promozione *10、 Scatola Scelta Migliora *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"tr-TR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10-dk Eğitim Hızlandırma *10、 10-dk Araştırma Hızlandırma *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Elmas *50、 10-dk Eğitim Hızlandırma *10、 10-dk Araştırma Hızlandırma *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Elmas *100、 10-dk Eğitim Hızlandırma *10、 10-dk Araştırma Hızlandırma *10、 10-dk İnşa Hızlandırma *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Elmas *200、 10-dk Eğitim Hızlandırma *10、 10-dk Araştırma Hızlandırma *10、 10-dk İnşa Hızlandırma *10、 Marcus Parçası *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10-dk Eğitim Hızlandırma *10、 10-dk Araştırma Hızlandırma *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Elmas *200、 60-dk Eğitim Hızlandırma *10、 60-dk Araştırma Hızlandırma *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"5★ Kahraman Mükemmel Parça*5、İlerletme Seçim Kutusu *10、Büyütme Seçimi Kutusu *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Marcus Parçası *2、 İlerletme Seçim Kutusu II *10、 İlerletme Seçim Kutusu *10、 Büyütme Seçimi Kutusu *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"pl-PL":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10-min. Przyśpieszenie Szkolenia *10、 10-min. Przyśpieszenie Badań *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diament *50、 10-min. Przyśpieszenie Szkolenia *10、 10-min. Przyśpieszenie Badań *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diament *100、 10-min. Przyśpieszenie Szkolenia *10、 10-min. Przyśpieszenie Badań *10、 10-min. Przyśpieszenie Budowania *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diament *200、 10-min. Przyśpieszenie Szkolenia *10、 10-min. Przyśpieszenie Badań *10、 10-min. Przyśpieszenie Budowania *10、 Frag. Marcusa *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10-min. Przyśpieszenie Szkolenia *10、 10-min. Przyśpieszenie Badań *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diament *200、 60-min. Przyśpieszenie Szkolenia *10、 60-min. Przyśpieszenie Badań *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Idealny Frag. 5★ Herosa*5、Pudełko z Wyborem Promocji *10、Pudło Wyboru Wzmocnienia *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Frag. Marcusa *2、 Pudełko z Wyborem Promocji II *10、 Pudełko z Wyborem Promocji *10、 Pudło Wyboru Wzmocnienia *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"id-ID":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Speed up Training 10 menit *10、 Speed up R&D 10 menit *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamond *50、 Speed up Training 10 menit *10、 Speed up R&D 10 menit *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond *100、 Speed up Training 10 menit *10、 Speed up R&D 10 menit *10、 Speed up Pembangunan 10 menit *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond *200、 Speed up Training 10 menit *10、 Speed up R&D 10 menit *10、 Speed up Pembangunan 10 menit *10、 Fragmen Maqus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Speed up Training 10 menit *10、 Speed up R&D 10 menit *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"Diamond *200、 Speed up Training 60 menit *10、 Speed up R&D 60 menit *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"Fragmen Hero Universal 5★*5、Star up Choice Supply Box *10、Enhance Choice Supply Box *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"Fragmen Maqus *2、 Star up Choice Supply Box II *10、 Star up Choice Supply Box *10、 Enhance Choice Supply Box *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"ar-SA":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10* تسريع التدريب 10 دقائق、 10* تسريع الأبحاث 10 دقائق","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"50* الماس、 10* تسريع التدريب 10 دقائق、 10* تسريع الأبحاث 10 دقائق","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797289088311.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"100* الماس、 10* تسريع التدريب 10 دقائق、 10* تسريع الأبحاث 10 دقائق、 10* تسريع البناء 10 دقائق","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798945600502.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"200* الماس、 10* تسريع التدريب 10 دقائق、 10* تسريع الأبحاث 10 دقائق、 10* تسريع البناء 10 دقائق、 1* قطعة ماركوس","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10* تسريع التدريب 10 دقائق、 10* تسريع الأبحاث 10 دقائق","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171634926610173062.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872913683228.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635872938979077.png"],"awardDetail":"200* الماس、 10* تسريع التدريب 60 دقيقة、 10* تسريع الأبحاث 60 دقيقة","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878251026343.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png"],"awardDetail":"قطعة بطل متعددة 5★*5、10* صندوق ترقية النجوم、10* اختيار صندوق الإمدادات","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635879509258960.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878215466397.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635878269826223.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171636626422003025.png"],"awardDetail":"2* قطعة ماركوس、 صندوق ترقية النجوم II *10、 10* صندوق ترقية النجوم、 10* اختيار صندوق الإمدادات","state":"0","dailyLimit":"","activityLimit":"1"}]}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {});
const checkIsLogin = inject("checkIsLogin", () => {});
const listData = inject("listData", {});
const showTips = inject("showTips", (txt, code) => {});
const showGetSucc = inject("showGetSucc", (type, pic, name) => {});
const getAward = inject("getAward", (type, key) => {})
const giftInfo = inject("giftInfo", {});
const getCurLink = inject("getCurLink", (link) => {});
const openInvitePanel = inject("openInvitePanel", () => {})
const initActivity = inject("initActivity", () => {})
const canClickRefresh = inject("canClickRefresh", true);
compData.inviteeTaskList = [];
compData.inviterTaskList = [];
compData.inviteeOtherTaskList = [];
compData.activeTab = 'team';
let customEventIndex = 0; // 记录当前自定义事件下标
const firstInit = ref(true);
watch(
  () => listData,
  (value) => {
    customEventIndex = 0;
    if (value && value.teamTask) {
      value.teamTask.forEach((item, index) => {
        if (compData.teamTask[index] === undefined) {
          compData.teamTask[index] = {};
        }
        let pic = compData.teamTask[index].pic;
        let awardDetail = compData.teamTask[index].awardDetail;
        if (+item.ticket > 0 && firstInit.value) {
          compData.teamTask[index].pic = [pageData.lotteryIcon, ...pic];
          compData.teamTask[
            index
          ].awardDetail = `${langData.lotteryCoupon} *${item.ticket}、${awardDetail}`;
        }
        compData.teamTask[index].taskValue = item.sub_task_type;
        compData.teamTask[index].payLevelType = item.pay_level_type;
        compData.teamTask[index].num = item.each_pay;
        compData.teamTask[index].state = item.status;
        compData.teamTask[index].dailyLimit = item.limit?.daily_limit;
        compData.teamTask[index].activityLimit = item.limit?.activity_limit;
        compData.teamTask[index].key = item.key;
        let curTaskName =
          item.pay_level_type == "customize_level" ?
          langData.teamPayTotal :
          langData.teamPayEvery;
        // 储值任务名称加入官网储值标识
        if (item.task_type == "charge") {
          curTaskName = `${curTaskName}(${langData.officialPay})`;
        }
        compData.teamTask[index].taskName = curTaskName
          .replaceAll("${x}", item.reach || "")
          .replaceAll("${currency}", pageData.currency);
        // 自定义档位针对重置类型的处理
        if (item.pay_level_type == "customize_level") {
          compData.teamTask[index].dailyLimit =
            item.pay_reset_rule == "activity" ? -1 : 1;
          compData.teamTask[index].activityLimit =
            item.pay_reset_rule == "activity" ? 1 : -1;
        }
      });
      giftInfo.teamTask = compData.teamTask;
    }
    if (value && value.personalTask) {
      value.personalTask.forEach((item, index) => {
        if (compData.soloTask[index] === undefined) {
          compData.soloTask[index] = {};
        }
        let pic = compData.soloTask[index].pic;
        let awardDetail = compData.soloTask[index].awardDetail;
        if (+item.ticket > 0 && firstInit.value) {
          compData.soloTask[index].pic = [pageData.lotteryIcon, ...pic];
          compData.soloTask[
            index
          ].awardDetail = `${langData.lotteryCoupon} *${item.ticket}、${awardDetail}`;
        }
        compData.soloTask[index].taskValue = item.sub_task_type;
        compData.soloTask[index].payLevelType = item.pay_level_type;
        compData.soloTask[index].state = item.status;
        compData.soloTask[index].dailyLimit = item.limit?.daily_limit;
        compData.soloTask[index].activityLimit = item.limit?.activity_limit;
        compData.soloTask[index].key = item.key;
        let curTaskName =
          (item.sub_task_type === "events" ?
            compData.customEventList[customEventIndex++]?.eventName :
            langData[item.sub_task_type]) || '';
        if (item.pay_level_type == "customize_level") {
          curTaskName = langData.payTotalAll;
          // 自定义档位针对重置类型的处理
          compData.soloTask[index].dailyLimit =
            item.pay_reset_rule == "activity" ? -1 : 1;
          compData.soloTask[index].activityLimit =
            item.pay_reset_rule == "activity" ? 1 : -1;
        }
        if (item.pay_level_type == "fixed_level") {
          curTaskName = langData.pay_total;
        }
        // 储值任务名称加入官网储值标识
        if (item.task_type == "charge") {
          curTaskName = `${curTaskName}(${langData.officialPay})`;
        }
        compData.soloTask[index].taskName = curTaskName
          .replaceAll("${x}", item.reach || "")
          .replaceAll("${currency}", pageData.currency);
      });
      giftInfo.personalTask = compData.soloTask;
    }
    firstInit.value = false;
  }, {
    deep: true
  }
);
// 游戏内隐藏充值入口
const checkCanShow = (type) => {
  if (
        ["pay_total", "pay_order"].includes(type) &&
    bridge.runInsdk()
  ) {
    return false;
  }
  return true;
};

// 任务完成按钮文案
const getBtnText = (item) => {
  if (item.state == 1) {
    return langData.getBtn;
  }
  if (item.state == 2) {
    return langData.hasBtn;
  }
  if (item.taskValue == "pay_total" || item.taskValue == "pay_order") {
    return bridge.runInsdk() ? langData.noFinish : langData.toFinish;
  }
  if (
        [
          "first_login_game",
          "daily_login_game",
          "first_login_activity",
          "daily_login_activity",
          "events",
        ].includes(item.taskValue)
  ) {
    return langData.noFinish;
  } else {
    return langData.toFinish;
  }
};;
      // 队伍任务的click事件
      const u_c_OCV248_event_AXJ783= async (e)=>{
        try {compData.activeTab = 'team'} catch (error) {console.log(error)}
      };
      // 个人任务的click事件
      const u_c_MHT350_event_XSXX85= async (e)=>{
        try {compData.activeTab = 'personal'} catch (error) {console.log(error)}
      };
      // 刷新的click事件
      const u_c_KL1C31_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 我的背包的click事件
      const u_c_JGIQ33_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "活动任务-背包",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
pageData.curBagType = compData.activeTab == 'team' ? 'team_task' : 'personal_task'
pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 任务日志的click事件
      const u_c_6R6U21_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
pageData.curBagType = compData.activeTab == 'team' ? 'team_task' : 'personal_task'
pageData.taskLogPopupState = true} catch (error) {console.log(error)}
      };
      // 奖励项的click事件
      const u_c_67LY123_event_QUFC21= async (e,data)=>{
        try {showTips(data.awardDetail);} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_5EOB125_event_5IW625= async (e,taskItem,index)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (taskItem.state == 2) {
  // 已领取直接返回
  return;
}
const curType = compData.activeTab == 'team' ? 'team_task' : 'personal_task'

if (taskItem.state == 1) {
  // 领取奖励
  const res = getAward(curType, taskItem.key)
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "组队任务-领取按钮",
    eventReason: curType,
    eventValue: JSON.stringify(taskItem),
    gameId: pageData.gameId,
    aid: pageData.pageId,
  });
  // if (res.result == 1) {
  //   if (compData.activeTab == 'team') {
  //     compData.teamTask[index].state = 2;
  //     return;
  //   }
  //   compData.soloTask[index].state = 2;
  // }
  return;
}
// 未达成的情况
if (
  ["share_activity"].includes(
    taskItem.taskValue
  )
) {
  // 分享活动页面
  await openInvitePanel(true);
  
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "组队任务-分享任务",
    gameId: pageData.gameId,
    aid: pageData.pageId,
  });
  initActivity();
  return;
}
if (["pay_total", "pay_order"].includes(taskItem.taskValue)) {
  // 如果没有配置储值链接，不做任何操作
  if (!pageData.storeLink) {
    return;
  }
  // 如果游戏内访问，则不打开第三方链接
  if (bridge.runInsdk()) {
    return;
  }
  bridge.open(pageData.storeLink, "_blank");
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "组队任务-跳转支付页",
    gameId: pageData.gameId,
    aid: pageData.pageId,
  });
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.default{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.default{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.default{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.default{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.default{
.u_c_Q9IQ53.normal{
position:relative;

}
}.default{
.u_c_RB2H54.normal{
position:relative;

}
}.default{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.default{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.default{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.default{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.default{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.default{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.default{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.default{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.default{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.default{
.u_c_PHDI21.normal{
position:relative;

}
}.default{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.default{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.default{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.default{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.default{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.default{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.default{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.default{
.u_c_U4BS22.normal{
position:relative;

}
}.default{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.zh-CN{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.zh-CN{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.zh-CN{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.zh-CN{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.zh-CN{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.zh-CN{
.u_c_Q9IQ53.normal{
position:relative;

}
}.zh-CN{
.u_c_RB2H54.normal{
position:relative;

}
}.zh-CN{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.zh-CN{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.zh-CN{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.zh-CN{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-CN{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-CN{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-CN{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.zh-CN{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.zh-CN{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-CN{
.u_c_PHDI21.normal{
position:relative;

}
}.zh-CN{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-CN{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-CN{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-CN{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.zh-CN{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.zh-CN{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.zh-CN{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.zh-CN{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.zh-CN{
.u_c_U4BS22.normal{
position:relative;

}
}.zh-CN{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.zh-TW{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.zh-TW{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.zh-TW{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.zh-TW{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.zh-TW{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.zh-TW{
.u_c_Q9IQ53.normal{
position:relative;

}
}.zh-TW{
.u_c_RB2H54.normal{
position:relative;

}
}.zh-TW{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.zh-TW{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.zh-TW{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.zh-TW{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-TW{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-TW{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-TW{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.zh-TW{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.zh-TW{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-TW{
.u_c_PHDI21.normal{
position:relative;

}
}.zh-TW{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-TW{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-TW{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-TW{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.zh-TW{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.zh-TW{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.zh-TW{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.zh-TW{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.zh-TW{
.u_c_U4BS22.normal{
position:relative;

}
}.zh-TW{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.en-US{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.en-US{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.en-US{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.en-US{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.en-US{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.en-US{
.u_c_Q9IQ53.normal{
position:relative;

}
}.en-US{
.u_c_RB2H54.normal{
position:relative;

}
}.en-US{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.en-US{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.en-US{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.en-US{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.en-US{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.en-US{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.en-US{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.en-US{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.en-US{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.en-US{
.u_c_PHDI21.normal{
position:relative;

}
}.en-US{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.en-US{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.en-US{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.en-US{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.en-US{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.en-US{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.en-US{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.en-US{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.en-US{
.u_c_U4BS22.normal{
position:relative;

}
}.en-US{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ja-JP{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.ja-JP{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ja-JP{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ja-JP{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ja-JP{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ja-JP{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ja-JP{
.u_c_RB2H54.normal{
position:relative;

}
}.ja-JP{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ja-JP{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ja-JP{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ja-JP{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ja-JP{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ja-JP{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ja-JP{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ja-JP{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ja-JP{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ja-JP{
.u_c_PHDI21.normal{
position:relative;

}
}.ja-JP{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ja-JP{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ja-JP{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ja-JP{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ja-JP{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ja-JP{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ja-JP{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ja-JP{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ja-JP{
.u_c_U4BS22.normal{
position:relative;

}
}.ja-JP{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ko-KR{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.ko-KR{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ko-KR{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ko-KR{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ko-KR{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ko-KR{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ko-KR{
.u_c_RB2H54.normal{
position:relative;

}
}.ko-KR{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ko-KR{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ko-KR{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ko-KR{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ko-KR{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ko-KR{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ko-KR{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ko-KR{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ko-KR{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ko-KR{
.u_c_PHDI21.normal{
position:relative;

}
}.ko-KR{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ko-KR{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ko-KR{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ko-KR{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ko-KR{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ko-KR{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ko-KR{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ko-KR{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ko-KR{
.u_c_U4BS22.normal{
position:relative;

}
}.ko-KR{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.th-TH{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.th-TH{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.th-TH{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.th-TH{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.th-TH{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.th-TH{
.u_c_Q9IQ53.normal{
position:relative;

}
}.th-TH{
.u_c_RB2H54.normal{
position:relative;

}
}.th-TH{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.th-TH{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.th-TH{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.th-TH{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.th-TH{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.th-TH{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.th-TH{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.th-TH{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.th-TH{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.th-TH{
.u_c_PHDI21.normal{
position:relative;

}
}.th-TH{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.th-TH{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.th-TH{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.th-TH{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.th-TH{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.th-TH{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.th-TH{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.th-TH{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.th-TH{
.u_c_U4BS22.normal{
position:relative;

}
}.th-TH{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.vi-VN{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.vi-VN{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.vi-VN{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.vi-VN{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.vi-VN{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.vi-VN{
.u_c_Q9IQ53.normal{
position:relative;

}
}.vi-VN{
.u_c_RB2H54.normal{
position:relative;

}
}.vi-VN{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.vi-VN{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.vi-VN{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.vi-VN{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.vi-VN{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.vi-VN{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.vi-VN{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.vi-VN{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.vi-VN{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.vi-VN{
.u_c_PHDI21.normal{
position:relative;

}
}.vi-VN{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.vi-VN{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.vi-VN{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.vi-VN{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.vi-VN{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.vi-VN{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.vi-VN{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.vi-VN{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.vi-VN{
.u_c_U4BS22.normal{
position:relative;

}
}.vi-VN{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.de-DE{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.de-DE{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.de-DE{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.de-DE{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.de-DE{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.de-DE{
.u_c_Q9IQ53.normal{
position:relative;

}
}.de-DE{
.u_c_RB2H54.normal{
position:relative;

}
}.de-DE{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.de-DE{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.de-DE{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.de-DE{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.de-DE{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.de-DE{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.de-DE{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.de-DE{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.de-DE{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.de-DE{
.u_c_PHDI21.normal{
position:relative;

}
}.de-DE{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.de-DE{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.de-DE{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.de-DE{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.de-DE{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.de-DE{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.de-DE{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.de-DE{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.de-DE{
.u_c_U4BS22.normal{
position:relative;

}
}.de-DE{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.fr-FR{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.fr-FR{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.fr-FR{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.fr-FR{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.fr-FR{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.fr-FR{
.u_c_Q9IQ53.normal{
position:relative;

}
}.fr-FR{
.u_c_RB2H54.normal{
position:relative;

}
}.fr-FR{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.fr-FR{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.fr-FR{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.fr-FR{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.fr-FR{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.fr-FR{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.fr-FR{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.fr-FR{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.fr-FR{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.fr-FR{
.u_c_PHDI21.normal{
position:relative;

}
}.fr-FR{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.fr-FR{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.fr-FR{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.fr-FR{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.fr-FR{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.fr-FR{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.fr-FR{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.fr-FR{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.fr-FR{
.u_c_U4BS22.normal{
position:relative;

}
}.fr-FR{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ru-RU{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.ru-RU{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ru-RU{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ru-RU{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ru-RU{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ru-RU{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ru-RU{
.u_c_RB2H54.normal{
position:relative;

}
}.ru-RU{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ru-RU{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ru-RU{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ru-RU{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ru-RU{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ru-RU{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ru-RU{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ru-RU{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ru-RU{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ru-RU{
.u_c_PHDI21.normal{
position:relative;

}
}.ru-RU{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ru-RU{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ru-RU{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ru-RU{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ru-RU{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ru-RU{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ru-RU{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ru-RU{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ru-RU{
.u_c_U4BS22.normal{
position:relative;

}
}.ru-RU{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.es-ES{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.es-ES{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.es-ES{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.es-ES{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.es-ES{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.es-ES{
.u_c_Q9IQ53.normal{
position:relative;

}
}.es-ES{
.u_c_RB2H54.normal{
position:relative;

}
}.es-ES{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.es-ES{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.es-ES{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.es-ES{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.es-ES{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.es-ES{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.es-ES{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.es-ES{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.es-ES{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.es-ES{
.u_c_PHDI21.normal{
position:relative;

}
}.es-ES{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.es-ES{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.es-ES{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.es-ES{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.es-ES{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.es-ES{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.es-ES{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.es-ES{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.es-ES{
.u_c_U4BS22.normal{
position:relative;

}
}.es-ES{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.pt-PT{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.pt-PT{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.pt-PT{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.pt-PT{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.pt-PT{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.pt-PT{
.u_c_Q9IQ53.normal{
position:relative;

}
}.pt-PT{
.u_c_RB2H54.normal{
position:relative;

}
}.pt-PT{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.pt-PT{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.pt-PT{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.pt-PT{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pt-PT{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pt-PT{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pt-PT{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.pt-PT{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.pt-PT{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pt-PT{
.u_c_PHDI21.normal{
position:relative;

}
}.pt-PT{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pt-PT{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pt-PT{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pt-PT{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.pt-PT{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.pt-PT{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.pt-PT{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.pt-PT{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.pt-PT{
.u_c_U4BS22.normal{
position:relative;

}
}.pt-PT{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.it-IT{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.it-IT{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.it-IT{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.it-IT{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.it-IT{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.it-IT{
.u_c_Q9IQ53.normal{
position:relative;

}
}.it-IT{
.u_c_RB2H54.normal{
position:relative;

}
}.it-IT{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.it-IT{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.it-IT{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.it-IT{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.it-IT{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.it-IT{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.it-IT{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.it-IT{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.it-IT{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.it-IT{
.u_c_PHDI21.normal{
position:relative;

}
}.it-IT{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.it-IT{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.it-IT{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.it-IT{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.it-IT{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.it-IT{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.it-IT{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.it-IT{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.it-IT{
.u_c_U4BS22.normal{
position:relative;

}
}.it-IT{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.tr-TR{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.tr-TR{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.tr-TR{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.tr-TR{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.tr-TR{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.tr-TR{
.u_c_Q9IQ53.normal{
position:relative;

}
}.tr-TR{
.u_c_RB2H54.normal{
position:relative;

}
}.tr-TR{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.tr-TR{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.tr-TR{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.tr-TR{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.tr-TR{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.tr-TR{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.tr-TR{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.tr-TR{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.tr-TR{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.tr-TR{
.u_c_PHDI21.normal{
position:relative;

}
}.tr-TR{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.tr-TR{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.tr-TR{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.tr-TR{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.tr-TR{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.tr-TR{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.tr-TR{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.tr-TR{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.tr-TR{
.u_c_U4BS22.normal{
position:relative;

}
}.tr-TR{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.pl-PL{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.pl-PL{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.pl-PL{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.pl-PL{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.pl-PL{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.pl-PL{
.u_c_Q9IQ53.normal{
position:relative;

}
}.pl-PL{
.u_c_RB2H54.normal{
position:relative;

}
}.pl-PL{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.pl-PL{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.pl-PL{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.pl-PL{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pl-PL{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pl-PL{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pl-PL{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.pl-PL{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.pl-PL{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pl-PL{
.u_c_PHDI21.normal{
position:relative;

}
}.pl-PL{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pl-PL{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pl-PL{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pl-PL{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.pl-PL{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.pl-PL{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.pl-PL{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.pl-PL{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.pl-PL{
.u_c_U4BS22.normal{
position:relative;

}
}.pl-PL{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.id-ID{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.id-ID{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.id-ID{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.id-ID{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.id-ID{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.id-ID{
.u_c_Q9IQ53.normal{
position:relative;

}
}.id-ID{
.u_c_RB2H54.normal{
position:relative;

}
}.id-ID{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.id-ID{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.id-ID{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.id-ID{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.id-ID{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.id-ID{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.id-ID{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.id-ID{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.id-ID{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.id-ID{
.u_c_PHDI21.normal{
position:relative;

}
}.id-ID{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.id-ID{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.id-ID{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.id-ID{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.id-ID{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.id-ID{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.id-ID{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.id-ID{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.id-ID{
.u_c_U4BS22.normal{
position:relative;

}
}.id-ID{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ar-SA{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697899-69.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
color:#c5c5c4;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}

.u_c_DIDC46.normal .highlight{
color:#ffdd7b;
font-weight:600;

}
}.ar-SA{
.u_c_TCEI47.normal{
position:relative;
width:7.55rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749306-57.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ar-SA{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ar-SA{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ar-SA{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ar-SA{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ar-SA{
.u_c_RB2H54.normal{
position:relative;

}
}.ar-SA{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
color:#c5c5c4;
font-size:0.31rem;
background-color:#341f20;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ar-SA{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ar-SA{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#c5c5c4;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ar-SA{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ar-SA{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ar-SA{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ar-SA{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ar-SA{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ar-SA{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ar-SA{
.u_c_PHDI21.normal{
position:relative;

}
}.ar-SA{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ar-SA{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ar-SA{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ar-SA{
.u_c_67LY123.normal{
position:relative;
width:1.12rem;
height:1.12rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697549-55.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ar-SA{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ar-SA{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ar-SA{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
color:#c5c5c4;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#7b5450;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ar-SA{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ar-SA{
.u_c_U4BS22.normal{
position:relative;

}
}.ar-SA{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}
</style>
